module.exports = __webpack_public_path__ + "static/media/sultron.53aef9bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/climasense/cenicilla_tomate/preventiva/sultron.png
// module id = 2390
// module chunks = 3